<script setup lang="ts">
const { t, locale } = useI18n()
const { isTabletPortraitDown } = useScreenSize()
const globalStore = useGlobalStore()

const siteURL = computed(() => {
  const utm = 'utm_source=rdi&utm_medium=banner_header&utm_campaign=createyourcatalog';
  
  if (locale.value === 'pt-BR') {
    return `https://rediredi.com/br/plano-pro?${utm}`;
  }
  if (locale.value === 'es' || locale.value === 'en') {
    return `${globalStore.siteURL}/${locale.value}?${utm}`;
  }
  
  return `${globalStore.siteURL}/en?${utm}`;
})

const bannerDescription = computed(() => {
  if (isTabletPortraitDown.value) {
    return t('components.header.adBanner.mobileDescription')
  }
  return t('components.header.adBanner.description')
})

const { event } = useEvent()

const bannerImageLocalePath = computed(() => {
  const allowedLocales = ['pt-BR', 'es', 'en'];
  const folderPath = allowedLocales.includes(locale.value) ? locale.value : 'en';
  return `/images/ads/${folderPath}/ad-banner-person-v2.png`;
});
</script>
<template>
  <a
    class="ad-banner block bg-white"
    :href="siteURL"
    target="_blank"
    @click="event('product_catalog_freebanner')"
  >
    <div class="m-auto flex w-full items-stretch justify-between gap-2 xl:w-[1280px]">
      <div class="py-2 pl-4 sm:py-6 sm:pl-10">
        <h2 class="mb-1 text-sm text-[#3A4E4D] sm:mb-2 sm:text-3xl">
          {{ t('components.header.adBanner.title') }}
        </h2>
        <p class="mb-1 sm:mb-2 sm:text-sm text-xs text-[#3A4E4D]">{{ bannerDescription }}</p>
        <a
          class="flex min-h-[18px] w-fit items-center justify-center rounded-[4px] bg-[#19A944] px-3 text-[8px] font-semibold text-white sm:min-h-[32px] sm:rounded-md sm:text-base"
        >
          {{ t('components.header.adBanner.action') }}
        </a>
      </div>
      <div
        :style="`background-image: url(${bannerImageLocalePath});`"
        class="ad-banner-person flex w-[432px] flex-col items-end justify-end py-2 pr-2"
      >
        <span
          class="flex h-5 min-w-[26px] items-center justify-center rounded bg-[#C31162] px-1 text-[8px] font-semibold uppercase text-white"
        >
          {{ t('components.header.adBanner.info') }}
        </span>
      </div>
    </div>
  </a>
</template>
<style scoped>
.ad-banner-person {
  background-size: cover;
}
</style>
